import decodeToken from './decode-token';

const getAuthToken = () => sessionStorage.getItem('token') || null;

const getDecodedToken = (token = getAuthToken()) => {
  if (!token) {
    return null;
  }

  try {
    return decodeToken(token);
  } catch {
    return null;
  }
};

const getCurrentRole = (token = getAuthToken()) => {
  return getDecodedToken(token)?.role || null;
};

const clearSession = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('loggedUser');
  sessionStorage.removeItem('refresh_token');
  sessionStorage.removeItem('preferred_language');
};

export {
  getAuthToken,
  getDecodedToken,
  getCurrentRole,
  clearSession,
};